import React, { useState } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { Box, Text, Flex } from "samba-ui";
import styled from "styled-components";

import FeedList from "../../FeedList";
import { TAB_VIEW_HEADER_ORDER, FEED_TYPE_MAPPING } from "../../../constants";

const Header = styled(Box)`
  cursor: pointer;
  border: 1px solid transparent;
  border-top-left-radius: 0.25rem;
  border-top-right-radius: 0.25rem;
  padding: 1rem;
  background-color: ${p => (p.active ? "white" : "transparent")};
  border-color: ${p => (p.active ? "#dee2e6 #dee2e6 #fff" : "transparent")};

  &:hover {
    border-color: #dee2e6 #dee2e6 #fff;
  }
  margin-bottom: ${p => (p.active ? "-2px" : "0")};
`;

const Content = styled(Box)`
  display: ${p => (p.show ? "initial" : "none")};
`;

const TabView = ({ feeds, expand }) => {
  const [activeIndex, setActiveIndex] = useState(0);
  const headers = TAB_VIEW_HEADER_ORDER.filter(type => !!feeds[type]);
  return (
    <Box>
      <Flex
        width={880}
        alignItems="center"
        flexWrap="wrap"
        mb={3}
        borderBottom="1px solid #dee2e6"
      >
        {headers.map((type, index) => {
          return (
            <Header
              key={type}
              onClick={() => setActiveIndex(index)}
              active={index === activeIndex}
            >
              <Text
                fontSize={2}
                fontWeight={index === activeIndex ? 500 : 400}
                color={index === activeIndex ? "primary" : "secondary"}
              >
                {FEED_TYPE_MAPPING[type]}
              </Text>
            </Header>
          );
        })}
      </Flex>

      {headers.map((type, index) => {
        return (
          <Content key={type} show={index === activeIndex}>
            <FeedList type={type} expand={expand} feeds={feeds[type]} />
          </Content>
        );
      })}
    </Box>
  );
};

const groupFeeds = feeds =>
  feeds.reduce((acc, f) => {
    if (acc[f.type]) {
      acc[f.type] = acc[f.type].concat(f);
    } else {
      acc[f.type] = [f];
    }
    return acc;
  }, {});

const mapStateToProps = (state, props) => ({
  feeds: groupFeeds(props.feeds)
});

TabView.propTypes = {
  feeds: PropTypes.array,
  expand: PropTypes.bool
};

export default connect(
  mapStateToProps,
  null
)(TabView);
